import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Ne kadar sürede geliyorsunuz?",
    a: "Konya merkez ilçelerde (Karatay, Selçuklu, Meram) ortalama 15-20 dakikada yanınızdayız. İlçelere varış süresi konuma göre değişir; telefonu açtığınızda size net bir süre söylüyoruz.",
  },
  {
    q: "Fiyat nasıl belirleniyor, yolda sürpriz olur mu?",
    a: "Hayır, olmaz. Aracınızın durumunu ve konumunuzu telefonda söylüyorsunuz, ücreti de orada netleştiriyoruz. Yol üzerinde fiyat değişikliği yapmıyoruz.",
  },
  {
    q: "Gece de hizmet veriyor musunuz?",
    a: "Evet. Konya Çekicim 7/24 nöbettadır; gece, hafta sonu ve resmi tatillerde de yolda kalanlara destek oluruz.",
  },
  {
    q: "Araç çekilirken zarar görür mü?",
    a: "Hayır. Aracınız çekiciye özenle yüklenir ve sabitlenir; taşıma sürecinin tamamı güvence altındadır. Hasara karşı her aşamada özel dikkat gösteriyoruz.",
  },
  {
    q: "İl dışına araç taşıyor musunuz?",
    a: "Evet. Konya'dan Türkiye'nin her iline araç taşıyoruz. Şehirler arası transferde süreyi ve ücreti telefonda net olarak söylüyoruz.",
  },
  {
    q: "Hangi araçları çekiyorsunuz?",
    a: "Binek, SUV, ticari ve hafif ticari araçların yanı sıra motosiklet taşıyoruz. Lüks araçlar özel platform ile, hasarsız şekilde taşınır.",
  },
];

export default function Faq() {
  return (
    <section id="sss" data-testid="faq-section" className="py-16 lg:py-24 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-5"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand">Sık Sorulan Sorular</p>
          <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl text-white mt-3 leading-[0.95]">
            Merak edilenler
          </h2>
          <p className="text-slate-400 mt-5 leading-relaxed max-w-sm">
            Aradığınızda ne soracağınızı biliyoruz. Cevabı burada; gerisini telefonda 30 saniyede
            netleştiriyoruz.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-display uppercase text-lg sm:text-xl text-left text-white hover:text-brand hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
